import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';

@Component({
    selector: 'app-poll-review',
    templateUrl: './poll-review.component.html',
})
export class PollReviewComponent implements OnInit {

    @ViewChild('chart') chart: ElementRef;

    @Input('poll1') poll1: number;
    @Input('poll2') poll2: number;
    @Input() outsidePollColor: string;
    @Input() insidePollColor: string;
    @Input('title') title: string;
    @Input('backgroundColor') backgroundColor = 'white';
    @Input('fontColor') fontColor = 'white';
    @Input('label') label: string;

    public chartType = 'doughnut';
    public chartData: any[] = [];
    public chartLabels: any[] = [];
    public chartOptions: {} = {};
    public chartColors: any[] = [];

    constructor() {
    }

    ngOnInit(): void {
        this.chartOptions = {
            responsive: true,
            maintainAspectRatio: false,
            legend: {
                display: true,
                labels: {
                    fontColor: '#fff'
                }
            },
            tooltips: {
                enabled: false
            },
        };

        this.chartData = [
            {
                backgroundColor: [this.outsidePollColor, this.insidePollColor, this.backgroundColor],
                data: [this.poll1, 0, 100 - this.poll1]
            },
            {
                backgroundColor: [this.outsidePollColor, this.insidePollColor, this.backgroundColor],
                data: [0, this.poll2, 100 - this.poll2]
            }
        ];
        this.chartLabels = [this.poll1, this.poll2];
        this.chartColors = [this.outsidePollColor, this.insidePollColor, this.backgroundColor,this.outsidePollColor, this.insidePollColor, this.backgroundColor];
    }
}



